import { module as Module } from 'modujs';

export default class DrawSvg extends Module {
    constructor(m) {
        super(m);

        // UI
        this.$paths = this.el.querySelectorAll('path');
    }

    init() {
        if (window.isReducedMotion) {
            return;
        }

        if (this.isHidden(this.el)) {
            return;
        }

        try {
            this.$paths.forEach(($path, index) => {
                const length = $path.getTotalLength();
                const duration = `${Math.min(length / 120, 1.5)}s`;

                $path.style.setProperty('--index', index);
                $path.style.setProperty('--length', length);
                $path.style.setProperty('--duration', duration);
            });
        } catch (err) {
            console.warn('[DrawSVG.init] Could not animate paths', this.el, err);
        }

        this.destroy()
    }

    isHidden(elem) {
        const styles = window.getComputedStyle(elem);
        return styles.display === 'none' || styles.visibility === 'hidden';
    }

    destroy() {
        super.destroy();
    }
}
